import axios from "axios";
import { buildApiUrl, encodePathValue, headersRequest } from "../helpers";

// Capa HTTP del módulo "Iniciativas de IA" (spec 008, Incremento 1: Registro). Molde:
// services/projectStatus.js + services/retroBoard.js. Todo por axios + buildApiUrl/encodePathValue/
// headersRequest (credentials incluidas por headersRequest, header user_lg del idioma ya incluido —
// lo consume SP_INIA_CATALOGOS_LISTAR/SP_INIA_LISTAR vía @Idioma en el controlador). Los errores de
// negocio (400 CAMPOS_OBLIGATORIOS / 409 ESTADO_NO_EDITABLE / ESTADO_NO_ELIMINABLE) se dejan propagar
// (axios rechaza en status >= 400); el caller lee el `code` con getIniciativaErrorCode, igual que
// getRetroErrorCode en services/retroBoard.js.

const RESOURCE = "iniciativas-ia";

export const IniciativasIAServices = {
  // GET /apiTM/iniciativas-ia/catalogos -> { clusters, clubhouses, tiposIA, vigilancia, checklistItems, usuarios }
  getCatalogos: async () => {
    const requestUrl = buildApiUrl(`${RESOURCE}/catalogos`);
    const result = await axios.get(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // GET /apiTM/iniciativas-ia/kpi -> { Total, F1, F2, F3 }
  getKpi: async () => {
    const requestUrl = buildApiUrl(`${RESOURCE}/kpi`);
    const result = await axios.get(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // GET /apiTM/iniciativas-ia -> [ { IdIniciativa, Codigo, Nombre, ... } ]
  listIniciativas: async () => {
    const requestUrl = buildApiUrl(RESOURCE);
    const result = await axios.get(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // GET /apiTM/iniciativas-ia/:id -> { ...ids crudos de la iniciativa, Checklist: [...] }
  getIniciativa: async (id) => {
    const requestUrl = buildApiUrl(`${RESOURCE}/${encodePathValue(id)}`);
    const result = await axios.get(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // POST /apiTM/iniciativas-ia -> 201 { IdIniciativa, Codigo }
  createIniciativa: async (payload) => {
    const requestUrl = buildApiUrl(RESOURCE);
    const result = await axios.post(requestUrl, payload, headersRequest(requestUrl));
    return result.data;
  },

  // PUT /apiTM/iniciativas-ia/:id -> 200 { IdIniciativa, Codigo }
  updateIniciativa: async (id, payload) => {
    const requestUrl = buildApiUrl(`${RESOURCE}/${encodePathValue(id)}`);
    const result = await axios.put(requestUrl, payload, headersRequest(requestUrl));
    return result.data;
  },

  // DELETE /apiTM/iniciativas-ia/:id -> 200 (borrado lógico)
  deleteIniciativa: async (id) => {
    const requestUrl = buildApiUrl(`${RESOURCE}/${encodePathValue(id)}`);
    const result = await axios.delete(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // Incrementos 2-3 (plan.md §14.1). Mismo patrón axios + buildApiUrl/encodePathValue/headersRequest.

  // GET /apiTM/iniciativas-ia/champions -> { esChampion, champions: [{IdUsuario, NombreCompleto, Correo}] }
  getChampions: async () => {
    const requestUrl = buildApiUrl(`${RESOURCE}/champions`);
    const result = await axios.get(requestUrl, headersRequest(requestUrl));
    return result.data;
  },

  // POST /apiTM/iniciativas-ia/:id/estado -> 200 (body: { accion, IdChampion?, Comentario? })
  cambiarEstado: async (id, payload) => {
    const requestUrl = buildApiUrl(`${RESOURCE}/${encodePathValue(id)}/estado`);
    const result = await axios.post(requestUrl, payload, headersRequest(requestUrl));
    return result.data;
  },

  // POST /apiTM/iniciativas-ia/:id/habilitar
  // -> 200 { IdProyecto, CodigoProyecto, NombreProyecto, NombreGerente, Reactivado }
  habilitar: async (id, payload) => {
    const requestUrl = buildApiUrl(`${RESOURCE}/${encodePathValue(id)}/habilitar`);
    const result = await axios.post(requestUrl, payload, headersRequest(requestUrl));
    return result.data;
  },
};

// Extrae el `code` de negocio de un error de axios: 400 { code: "CAMPOS_OBLIGATORIOS" | "CHAMPION_REQUERIDO"
// | "COMENTARIO_REQUERIDO", ... }, 403 { code: "NO_AUTORIZADO" } (incrementos 2-3, plan.md §18.9), 409
// { code: "ESTADO_NO_EDITABLE" | "ESTADO_NO_ELIMINABLE" | "TRANSICION_INVALIDA" } (plan.md §8.8/§18.9).
// Devuelve null si no aplica (error de red / 404 / 500 genérico / otro status).
export const getIniciativaErrorCode = (err) => {
  const status = err && err.response && err.response.status;
  if (status !== 400 && status !== 409 && status !== 403) return null;
  return (err.response.data && err.response.data.code) || null;
};

export default IniciativasIAServices;
